import React from "react";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json"
import Popup from 'devextreme-react/popup';
import ScrollView from "devextreme-react/scroll-view";
import { GridLayout } from "../../../common/GridLayout";
import { Localization } from "../../../common/Localization";
import DataGrid, {
    Column,
    Editing,
    Paging,
    RequiredRule,
    StringLengthRule,
    Toolbar,
    Item,
    FilterRow,
    FilterPanel,
    FilterBuilderPopup,
    ColumnChooser,
    ColumnChooserSearch,
    ColumnFixing,
    Sorting,
    Export,
    Pager,
    HeaderFilter,
    Lookup,
    StateStoring
} from 'devextreme-react/data-grid';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

import { SelectBox } from "devextreme-react/select-box";
import { Button } from 'devextreme-react/button';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import AddOrchardCode from "./AddOrchardCode";

const filterBuilderPopupPosition = {
    of: window,
    at: 'top',
    my: 'top',
    offset: { y: 10 },
};
const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';

const gridKey = "c6f5048a-f512-4247-9e65-2e204ccfb4ef";
class OrchardCodesGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItemKeys: [],                       
            isAddOrchardVisible: false,
            currentLayout: "Default",
        };
        accessToken = props.oidc.user.access_token;
        this.onContentReady = this.onContentReady.bind(this);
        this.AddOrchardClick = this.AddOrchardClick.bind(this);
        this.handleClosePopUpCallback = this.handleClosePopUpCallback.bind(this);       
        this.statusArr = [
            { id: 1, name: 'Active', value: 'A' },
            { id: 2, name: 'Inactive', value: 'I' }];
        this.OrchardCodeEditorOptions = {
            maxLength: 12
        };
        this.OrchardDataSource = createStore({
            key: "id",
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Orchard.GetAllOrchards}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        });
        
        this.dataSource = createStore({
            key: 'rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Orchard.GetAllOrchards}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${routes.Orchard.UpdateOrchardCode}`,
            deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.Orchard.DeleteOrchardCode}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };           
            }
        });
    }
    AddOrchardClick() {
        this.setState({
            isAddOrchardVisible: true,
        });
    }
    setOrchardStateValue(rowData, value) {        
        this.defaultSetCellValue(rowData, value);
    }
    handleClosePopUpCallback() {
        this.setState({
            isAddOrchardVisible: false,
        });
        dataGrid.current.instance().refresh();
    };
    setCurrentLayout =(value)=>{
        this.setState({
          currentLayout:value
        })
      }
      loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null, this.state.currentLayout);}
      saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}    
    render() {
        return (
            <div className="h-100">
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
                ref={dataGrid}
                    onContentReady={this.onContentReady}
                    showBorders={true}
                    className="FullPageGridHeight"
                    //selectedRowKeys={this.state.selectedItemKeys}
                    //onSelectionChanged={this.selectionChanged}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                >
                    {/** <Selection mode="multiple" />*/}
                    <Paging
                        enabled={true}
                    />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={allowedPageSizes}
                        showNavigationButtons={true}
                        showInfo={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <FilterBuilderPopup position={filterBuilderPopupPosition} />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <HeaderFilter visible={true} />
                    <ColumnFixing enabled={true} />,
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting mode="multiple" />
                    <Editing
                        mode="cell"
                        newRowPosition="first"
                        refreshMode="repaint"
                        allowUpdating={true}
                        allowAdding={true}
                        allowDeleting={true} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column dataField="code" editorOptions={this.OrchardCodeEditorOptions} caption="Orchard Code" setCellValue={this.setOrchardStateValue}>                        
                        <RequiredRule message="Orchard Code is required." />
                        <StringLengthRule message="Code must have at least 3 chracters and maximum 12" min={3} max={12} />
                    </Column>
                    <Column dataField="name" caption="Orchard Name"></Column>
                    <Column dataField="status" caption="Orchard Status" >
                        <Lookup
                            dataSource={this.statusArr}
                            displayExpr="name"
                            valueExpr="value"
                            defaultValue={"A"} />
                    </Column>
                    <Column dataField="comment" caption="Comment"></Column>                  
                    
                    <Toolbar>
                        <Item location="before">
                            <Button onClick={this.AddOrchardClick} text="Add Orchard" type="default" stylingMode="contained" className="margin-right" />
                        </Item>
                 <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
                {this.state.isAddOrchardVisible &&
                    <Popup
                        visible={this.state.isAddOrchardVisible}
                        onHiding={this.handleClosePopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title="Add Orchard"
                        container="#root"
                        closeOnOutsideClick={true}
                        height={600}
                        width={600}
                    >
                       <ScrollView width="100%" height="100%">
                            <AddOrchardCode parentCallback={this.handleClosePopUpCallback}
                            ></AddOrchardCode>
                        </ScrollView>
                    </Popup>}
            </div>
        );
    }
    onContentReady(e) {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", this.dataSource);
        }
    }
    selectionChanged(data) {
        this.setState({
            selectedItemKeys: data.selectedRowKeys,
        });
    }
    renderStatusField = (rowid, reviewStatusObject) => {
        console.log(reviewStatusObject, "order list");
        const onValueChanged = (e) => {
            if (e.component.__ignoreEvent) {
                e.component.__ignoreEvent = false;
                return;
            }
            let orderStatus = e.value.name;
            let rowid = e.value.rowid;
        };
        return (
            <div>
                <SelectBox
                    displayExpr="name"
                    valueExpr="value"
                    items={[{ id: 1, name: 'Active', value: 'A' }, { id: 2, name: 'Inactive', value: 'I' }]}
                    onValueChanged={(e) => onValueChanged(e)}
                ></SelectBox>
            </div>
        );
    };
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OrchardCodesGrid);